import helper from '@/libs/forms';


const frequencyOptions = [
  { id: 'monthly', name: 'Monthly' },
  { id: 'annual', name: 'Annually' },
];

export default {
  fields: [
    helper.simpleInput('text', 'Noteholder Name', null, 'noteholder', true),
    helper.simpleInput(
      'text', 'How Secured or Endorsed - Type of Collateral', null, 'collateralType', true,
    ),
    helper.currency('Amount', 'amount', true),
    helper.currency('Original Balance', 'originalBalance', true, 6),
    helper.currency('Current Balance', 'currentBalance', true, 6),
    helper.currency('Payment Amount', 'paymentAmount', true, 6),
    helper.simpleSelect('Frequency', 'frequency', true, frequencyOptions, null, 6),
  ],
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/liabilities/schemas/banks.js